import * as yup from 'yup';


export const editDiscountValidationSchema = (productPrice = 0, existingDiscountValues) => {
  return yup.object({
    price_type: yup
      .string()
      .required('Field is required'),
    price: yup
      .number()
      .nullable().typeError('Field is required')
      .when(
        'price_type',
        {
          is: (val) => val === 'percent',
          then: yup
            .number()
            .typeError('Field is required')
            .max(100, 'Max percentage discount 100%')
            .test(
              'price',
              'Discount already exist',
              (val) => {
                const values = existingDiscountValues?.filter(
                  (o) => o.price_type === 'percent'
                ) || [];

                if (!existingDiscountValues) {
                  return true;
                }

                const prices = values.map((v) => v.price);

                return !prices.includes(val);
              }
            )
            .required('Field is required')
        }
      )
      .when(
        'price_type',
        {
          is: (val) => val === 'fixed',
          then: yup
            .number()
            .typeError('Field is required')
            .min(0, 'Discount must be greater or equal 0')
            .max(productPrice, `Discount can't be greater $${productPrice.toFixed(2)}`)
            .test(
              'price',
              'Discount already exist',
              (val) => {
                const values = existingDiscountValues?.filter(
                  (o) => o.price_type === 'fixed'
                ) || [];

                if (!existingDiscountValues) {
                  return true;
                }

                const prices = values.map((v) => v.price);

                return !prices.includes(val);
              }
            )
            .required('Field is required')
        }
      )
  });
};
